export default "__VITE_ASSET__Td2iLT6h__"